import { Stack } from "@mantine/core"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { useGetExportRequests } from "~/gen/api"
import { ExportRequestsTable } from "~/pages/Brand/DataTransfer/Export/ExortRequestsTable"

export const DataTransferExport = () => {
  const exportRequestsQuery = useGetExportRequests()

  return (
    <Stack>
      <DataFetchWrapper query={exportRequestsQuery}>
        {({ data }) => (
          <ExportRequestsTable data={data.data} total={data.data.length} />
        )}
      </DataFetchWrapper>
    </Stack>
  )
}
